// src/pages/Certifications.jsx
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
// removed unused imports
import NavTabs from '../components/NavTabs';

const images = [
  {
    src: '/cert1.jpg',
    title: '사업자등록증'
  },
  {
    src: '/cert2.jpg',
    title: '기술혁신형 중소기업(Inno-Biz) 확인서'
  },
  {
    src: '/cert3.jpg',
    title: '벤처기업확인서'
  },
  {
    src: '/cert4.jpg',
    title: '품질인증(Q-Mark)지정서'
  },
  {
    src: '/cert5.jpg',
    title: '품질경영시스템인증서 (영문)'
  }
];

function Certifications() {
  const [selectedIdx, setSelectedIdx] = useState(null);

  const nextImage = (e) => {
    e?.stopPropagation();
    setSelectedIdx((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e?.stopPropagation();
    setSelectedIdx((prev) => (prev - 1 + images.length) % images.length);
  };

  const closeModal = () => setSelectedIdx(null);

  return (
    <div className="text-gray-800">
      {/* 배경 헤더 섹션 */}
      <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white">제이디윈태크</h1>
          <p className="mt-4 text-white text-lg md:text-xl">
            JDWinTech은 스마트 공조와 배연 시스템의 선도 기업입니다.
          </p>
        </div>

        {/* 하단 탭 메뉴 */}
        <NavTabs />
      </section>

      {/* 이미지 리스트 섹션 */}
      <section className="py-16 px-6 md:px-20 max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold mb-8 text-center">특허/인증/수상</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6">
          {images.map((img, idx) => (
            <div key={idx} className="text-center">
              <img
                src={img.src}
                alt={img.title}
                className="w-full h-auto rounded-md cursor-pointer shadow-md hover:scale-105 transition"
                onClick={() => setSelectedIdx(idx)}
              />
              <p className="mt-2 text-sm font-medium">{img.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 이미지 확대 모달 */}
      {selectedIdx !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 cursor-zoom-out"
          onClick={closeModal}
        >
          <button onClick={prevImage} className="absolute left-4 text-white p-2" onMouseDown={(e) => e.stopPropagation()}>
            <ChevronLeft size={40} />
          </button>
          <img
            src={images[selectedIdx].src}
            alt={images[selectedIdx].title}
            className="max-w-full max-h-[90vh] rounded-lg shadow-lg cursor-default"
            onClick={nextImage}
          />
          <button onClick={nextImage} className="absolute right-4 text-white p-2" onMouseDown={(e) => e.stopPropagation()}>
            <ChevronRight size={40} />
          </button>
        </div>
      )}
    </div>
  );
}

export default Certifications;